import TabBar from './TabBar.connect';
import * as TabBarSelectors from './TabBar.selectors';

TabBar.selectors = TabBarSelectors;

export default TabBar;
